import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { WidgetLayoutResponse } from '@frontend/sports/types/components/widget';
import { Observable } from 'rxjs';

import { WidgetContextService } from './widget-context.service';

@Injectable({ providedIn: 'root' })
export class WidgetResolver {
    readonly #widgetContextService = inject(WidgetContextService);

    resolve(route: ActivatedRouteSnapshot): Observable<WidgetLayoutResponse> {
        return this.#widgetContextService.getLayout(this.#widgetContextService.getContext({ snapshot: route }));
    }

    preResolve(route: ActivatedRouteSnapshot) {
        this.#widgetContextService.preResolveWidgets(route).subscribe();
    }
}
